/*eslint-disable*/
import Vue from 'vue';
import Router from 'vue-router';
import Result from './pages/Result.vue';
import Resultpreview from './pages/Resultpreview.vue';
import Index from './pages/Index.vue';
import Indexpreview from './pages/Indexpreview.vue';
import Invaild from './pages/Invaild.vue';
import InvaildEarly from './pages/Invaild_early.vue';
import Error from './pages/Error.vue';
import ErrorFinal from './pages/ErrorFinal.vue';

const useEnv = JSON.parse(process.env.VUE_APP_USE_ENV);

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: useEnv ? '${VUE_APP_PUBLIC_PATH}' : process.env.VUE_APP_PUBLIC_PATH,
  routes: [
    {
      path: '/result',
      name: 'result',
      component: Result
    },
    {
      path: '/resultpreview',
      name: 'resultpreview',
      component: Resultpreview
    },
    {
      path: '/Index',
      name: 'Index',
      component: Index
    },
    {
      path: '/Indexpreview',
      name: 'Indexpreview',
      component: Indexpreview
    },
    {
      path: '/Invaild',
      name: 'Invaild',
      component: Invaild
    },
    {
      path: '/Invaild_early',
      name: 'Invaild_early',
      component: InvaildEarly
    },
    {
      path: '/Error',
      name: 'Error',
      component: Error
    },
    {
      path: '/ErrorFinal',
      name: 'ErrorFinal',
      component: ErrorFinal
    }
  ]
});
